var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('section', {
    staticClass: "activity-stage beginning-letter"
  }, [_c('div', {
    staticClass: "images-holder",
    class: {
      isMobileView: _vm.isMobile
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.currentStep.image,
      "alt": _vm.currentStep.imageName
    }
  })]), _vm._t("keyboard")], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }